import { FileSelect } from '@modules/common/components/FileSelect';
import { useUploadMediaFile } from '@modules/dashboard/hooks';
import { CircularProgress, Stack, Typography } from '@mui/material';

interface DashboardImageUploaderProps {
  onChange: () => void;
  isDisabled?: boolean;
  onCompleted: (url: string) => void;
  id: string;
}

export function DashboardImageUploader({
  isDisabled = false,
  onChange,
  onCompleted,
  id,
}: DashboardImageUploaderProps) {
  const [uploadMediaFile, { error, isUploading }] = useUploadMediaFile({
    onCompleted,
  });
  const onFileSelect = async (selectedFile: File | undefined) => {
    if (!selectedFile) {
      return;
    }

    onChange();
    await uploadMediaFile(selectedFile);
  };

  return (
    <Stack direction="column" spacing={1} alignItems="center">
      {isUploading ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <CircularProgress size={16} />
          <Typography variant="caption" color="text.secondary">
            Uploading, please wait...
          </Typography>
        </Stack>
      ) : (
        <FileSelect
          id={`image_${id}`}
          acceptFileType="image/gif, image/jpeg, image/jpg, image/png, image/webp"
          onFileSelect={onFileSelect}
          buttonProps={{
            variant: 'contained',
            color: 'primary',
            size: 'small',
            disabled: isDisabled,
          }}
          buttonLabel="Upload Image"
        />
      )}
      {error ? (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
}
